const CMS = {
    acos: 'Acos',
    adobe: 'Adobe CMS',
    aem: 'AEM',
    baywsf: 'BayWSF',
    cascade: 'Cascade',
    civicengage_central: 'CivicEngage Central',
    civicengage_evolve: 'CivicEngage Evolve',
    civicengage_open: 'Web Open',
    corepublish: 'CorePublish',
    craft: 'Craft CMS',
    custom: 'Custom CMS',
    drupal: 'Drupal',
    dynamicweb: 'Dynamicweb',
    elcom: 'Elcom',
    episerver: 'EPiServer',
    finalsite: 'Finalsite',
    gabbart: 'Gabbart',
    hubspot: 'Hubspot',
    icreate: 'iCreate',
    joomla: 'Joomla',
    kentico: 'Kentico',
    konform: 'Konform',
    municode: 'Municode',
    omniupdate: 'Omniupdate',
    opencities: 'OpenCities',
    plone: 'Plone',
    presence: 'Presence',
    publicera: 'Publicera',
    shopify: 'Shopify',
    silverstripe: 'SilverStripe',
    simsite: 'SIMsite',
    sitecore: 'Sitecore',
    sitefinity: 'Sitefinity',
    sitevision: 'Sitevision',
    smart_sites: 'Smart Sites',
    special: 'Custom meta header',
    squarespace: 'Squarespace',
    squiz: 'Squiz',
    umbraco: 'Umbraco',
    wordpress: 'WordPress',
    wordpress_multisite: 'WordPress Multisite',
};
const CmsWithSubdomain = [
    'shopify', 'opencities', 'adobe', 'simsite',
];
const CmsRequiresSubdomain = [
    'shopify', 'adobe', 'simsite',
];
const CmsWithPath = [
    'craft',
];
const CmsWithURL = [
    'sitecore', 'omniupdate', 'publicera', 'sitefinity', 'custom', 'cascade', 'aem', 'acos', 'baywsf',
];
const CmsURLFieldDefinition = {
    custom: 'base_url',
    episerver: 'base_url',
    aem: 'cms_url',
};
const CmsWithOptionalURL = [
    'drupal', 'kentico', 'episerver',
];


// Don't make changes to the below getter functions
export function getCmsOptions (addCMSTemplate: boolean): { name: string, id: string }[] {
    const options = Object.entries(CMS)
        .map(([id, name]) => {
            return {
                id,
                name,
            };
        })
        .sort((a, b) => {
            return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
        });

    if (addCMSTemplate) {
        return [
            { id: 'cms_template', name: 'CMS template' },
        ].concat(options);
    }

    return options;
}
export function cmsHasSubDomain (cmsId: string): boolean {
    return CmsWithSubdomain.includes(cmsId);
}
export function isCmsRequiresSubDomain (cmsId: string): boolean {
    return CmsRequiresSubdomain.includes(cmsId);
}
export function cmsHasPath (cmsId: string): boolean {
    return CmsWithPath.includes(cmsId);
}
export function cmsHasURL (cmsId: string): boolean {
    return CmsWithURL.includes(cmsId);
}
export function resolveCmsURLField (cmsId: string): string {
    const cmsUrlFieldDefinition = CmsURLFieldDefinition[cmsId];
    return cmsUrlFieldDefinition || 'url';
}
export function cmsHasOptionalURL (cmsId: string): boolean {
    return CmsWithOptionalURL.includes(cmsId);
}
